import Lottie from 'lottie-react';
import React, { useEffect, useRef, useState, } from 'react';
import "./QuestionAnsStyle.css";
import { ToastContainer, toast } from "react-toastify";
import { map } from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserSubscription } from '../../service/slice/AuthSlice';
import { useReactToPrint } from 'react-to-print';
import { useLocation, useNavigate } from 'react-router-dom';



function QuestionAnsView() {
    const navigate = useNavigate();
    const location = useLocation();
    const questionData = location?.state;

    useEffect(() => {
        if (!questionData) {
            navigate('/')
        } else {
            document.getElementById('loading').style.display = "none";
            document.getElementById('answer').style.display = "block";
            const responseDiv = document.getElementById('answer');
            responseDiv.innerHTML = '';
            const html = chatGPTResponseToHTML(questionData?.response);
            typeHTML(responseDiv, html, 10);
        }
    }, [])


    function gemeniResponseToHTML(text) {
        if (!text) return "";

        let html = text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
        // .replaceAll("`", "$$");
        html = html.replace(/\r?\n/g, "<br>");
        html = html.replace(/^(\s*)(-{3,}|\*{3,}|_{3,})(\s*)$/gm, "<hr>");
        html = html.replace(/```([\s\S]*?)```/g, "<pre><code>$1</code></pre>");
        html = html.replace(/`([^`]+)`/g, "<code>$1</code>");
        // html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
        // html = html.replace(/\$\$(.*?)\$\$/g, "<katex-element>$1</katex-element>");
        // html = html.replace(/\$(.*?)\$/g, "<katex-element>$1</katex-element>");
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$(.*?)\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/(?<!\*)\*(?!\*)(.*?)\*(?<!\*)/g, "<em>$1</em>");
        html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
        html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
        html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");
        html = html.replace(/^> (.*$)/gim, "<blockquote>$1</blockquote>");
        html = html.replace(/^\s*[-*] (.*$)/gim, "<li>$1</li>");
        html = html.replace(/(<li>.*<\/li>\n?)+/gim, match => `<ul>${match}</ul>`);
        html = html.replace(/\n{2,}/g, "</p><p>");
        html = `<div>${html}</div>`;
        html = html.replace(/<p><\/p>/g, "");
        return html.trim();
    }

    function chatGPTResponseToHTML(text) {
        if (!text) return "";

        let html = text;

        // Escape HTML special chars to prevent injection
        html = html.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");

        // Convert horizontal rules (ChatGPT uses --- or *** or ___)
        html = html.replace(/^(\*\*\*|---|___)$/gm, "<hr>");
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field class="mathfield" virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$(.*?)\$/g, '<math-field class="mathfield" virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        // Convert headings (#, ##, ###)
        html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
        html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
        html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");

        // Bold and italics (**bold**, *italic*)
        html = html.replace(/\*\*(.*?)\*\*/gim, "<b>$1</b>");
        html = html.replace(/\*(.*?)\*/gim, "<i>$1</i>");

        // Inline code `code`
        html = html.replace(/`([^`]+)`/gim, "<code>$1</code>");

        // Code blocks ```js ... ```
        html = html.replace(/```(\w+)?\n([\s\S]*?)```/gim, (match, lang, code) => {
            return `<pre><code class="language-${lang || ''}">${code.trim()}</code></pre>`;
        });

        // Ordered lists
        html = html.replace(/^\d+\.\s+(.*)$/gim, "<ol><li>$1</li></ol>");
        html = html.replace(/<\/ol>\s*<ol>/gim, ""); // merge consecutive lists

        // Unordered lists
        html = html.replace(/^[*-]\s+(.*)$/gim, "<ul><li>$1</li></ul>");
        html = html.replace(/<\/ul>\s*<ul>/gim, ""); // merge consecutive lists

        // Blockquotes
        html = html.replace(/^>\s+(.*)$/gim, "<blockquote>$1</blockquote>");

        // Newlines to <br> (for paragraph separation)
        html = html.replace(/\n{2,}/g, "</p><p>");
        html = "<p>" + html + "</p>";

        // Clean up multiple <p> or <br> tags
        html = html.replace(/<p><\/p>/g, "");

        return html.trim();
    }

    // ✅ Typing animation for HTML content
    async function typeHTML(element, html, speed = 20) {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        for (let node of temp.childNodes) {
            await typeNode(node, element, speed);
        }
    }

    async function typeNode(node, parent, speed) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const el = document.createElement('span');
            parent.appendChild(el);
            for (let char of text) {
                el.appendChild(document.createTextNode(char));
                await new Promise(r => setTimeout(r, speed));
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const el = document.createElement(node.tagName.toLowerCase());
            for (let attr of node.attributes) el.setAttribute(attr.name, attr.value);
            parent.appendChild(el);
            for (let child of node.childNodes) {
                await typeNode(child, el, speed);
            }
        }
    }


    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({ componentRef });

    useEffect(() => {
        // const copyBtn = document.getElementById('copy');
        const printBtn = document.getElementById('print');
        const answer = document.getElementById('answer');

        // copyBtn.addEventListener('click', () => {
        //     const tmp = document.createElement('textarea');
        //     tmp.value = answer.innerText || '';
        //     document.body.appendChild(tmp); tmp.select(); document.execCommand('copy'); document.body.removeChild(tmp);
        //     copyBtn.textContent = 'Copied'; setTimeout(() => copyBtn.textContent = 'Copy', 800);
        // });
        printBtn.addEventListener('click', () => {
            // document.getElementsByClassName('left-side-bar')[0].classList.add("d-none")
            // window.print();
            // document.getElementsByClassName('left-side-bar')[0].classList.remove("d-none")
            printDiv('answer')
        });

    }, [])

    function printDiv(divId) {
        // Get the element
        const divToPrint = document.getElementById(divId);

        if (!divToPrint) {
            console.error('Div not found:', divId);
            return;
        }

        // Create a new window for printing
        const printWindow = window.open('', '_blank', 'width=800,height=600');

        // Write the div content and basic styles
        printWindow.document.write(`
    <html>
      <head>
        <title>Print Preview</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }
          .content {
            max-height: none;
            overflow: visible;
          }
        </style>
      </head>
      <body>
        <div class="content">
          ${divToPrint.innerHTML}
        </div>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        <\/script>
      </body>
    </html>
  `);

        printWindow.document.close();
    }


    return (
        <div className="wrap" >
            {/* <h1>Question (type or paste)</h1> */}
            <div className="card" style={{ padding: "16px" }}>
                <div className="result">
                    <div className="result-head">
                        <div className="result-title">Answer</div>
                        <div className="result-tools">
                            {/* <button className="btn button-flex d-flex">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M288 64C252.7 64 224 92.7 224 128L224 384C224 419.3 252.7 448 288 448L480 448C515.3 448 544 419.3 544 384L544 183.4C544 166 536.9 149.3 524.3 137.2L466.6 81.8C454.7 70.4 438.8 64 422.3 64L288 64zM160 192C124.7 192 96 220.7 96 256L96 512C96 547.3 124.7 576 160 576L352 576C387.3 576 416 547.3 416 512L416 496L352 496L352 512L160 512L160 256L176 256L176 192L160 192z" /></svg>
                                <span id="copy"> Copy</span>
                            </button> */}
                            <button className="btn button-flex d-flex" >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M128 128C128 92.7 156.7 64 192 64L405.5 64C422.5 64 438.8 70.7 450.8 82.7L493.3 125.2C505.3 137.2 512 153.5 512 170.5L512 208L128 208L128 128zM64 320C64 284.7 92.7 256 128 256L512 256C547.3 256 576 284.7 576 320L576 416C576 433.7 561.7 448 544 448L512 448L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 448L96 448C78.3 448 64 433.7 64 416L64 320zM192 480L192 512L448 512L448 416L192 416L192 480zM520 336C520 322.7 509.3 312 496 312C482.7 312 472 322.7 472 336C472 349.3 482.7 360 496 360C509.3 360 520 349.3 520 336z" /></svg>
                                <span id="print"> Print</span>
                            </button>
                        </div>
                    </div>
                    <div className="result-body" id="result" aria-live="polite" ref={componentRef}>
                        <p Style="color: #b2b0b0 !important">Your answer will display here.</p>
                        <div id="loading" Style="display:none">
                            <div className="skeleton" Style="width:70%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:95%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:60%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:85%"></div>
                        </div>

                        <div id="answer" Style="display:none">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuestionAnsView